import { LockResource, lockResource } from '@/resources/lock.resource';
import { AbstractModule } from './abstract.module';

export class LockModule extends AbstractModule<LockResource> {
  public state = { data: null };

  public actions = {
    /**
     * Znajduje blokadę dokumentu
     *
     * @param {*} context
     * @param {*} variables
     * @returns {Promise<any>}
     */
    findLock: (context: any, variables: any): Promise<any> => {
      return this.resource.lockFind(variables).then(lock => context.commit('saveLock', lock));
    }
  };

  public mutations = {
    /**
     * Zapisuje blokadę dokumentu
     *
     * @param {*} localState
     * @param {*} lock
     */
    saveLock: (localState: any, lock: any): void => {
      localState.data = lock;
    }
  };
}

export default new LockModule(lockResource);
